import { filter } from 'lodash';

import getSubDomainSkillsData from 'bundles/browse/components/Domain/constants/subDomainSkillsData';
import type { Skill } from 'bundles/browse/components/Domain/types/Domain';

export const getSkillsForSubDomain = (subDomainId: string): Array<Skill> => {
  const subDomainSkills = filter(getSubDomainSkillsData(), ['subDomainId', subDomainId]);
  return subDomainSkills;
};
